import Vue from 'vue'
import * as types from '../mutation-types'
import consumeApi from '../../api/consume'

export default {
    state: {
        appList: [],
        goodsList: {},
        playedGames: [],
        serverList: {}
    },
    getters: {
        areaList() {
            return {
                1: Vue.t('areaAsia'),
                2: Vue.t('areaAmerica'),
                3: Vue.t('areaEurope')
            }
        },
        playedGamesList(state) {
            let games = [];
            state.playedGames.forEach((game) => {
                games.push(parseInt(game.id));
            });
            return games;
        }
    },
    mutations: {
        [types.SET_APP_LIST](state, appList) {
            state.appList = appList;
        },
        [types.SET_GOODS_LIST](state, goods) {
            if (goods.appId !== 0) {
                state.goodsList[goods.appId] = goods.goodsList;
            }
        },
        [types.SET_USER_PLAYED_GAME](state, playedGames) {
            state.playedGames = playedGames;
        },
        [types.SET_SERVER_LIST](state, server) {
            if (!state.serverList[server.appId]) {
                state.serverList[server.appId] = {};
            }
            state.serverList[server.appId][server.areaId] = server.serverList
        }
    },
    actions: {
        [types.GET_APP_LIST]({commit}) {
            return new Promise((resolve, reject) => {
                consumeApi.getAppList((appList) => {
                    commit(types.SET_APP_LIST, appList);
                    resolve();
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [types.GET_GOODS_LIST]({commit}, appId) {
            return new Promise((resolve, reject) => {
                consumeApi.getGoodsList(appId, (goods) => {
                    commit(types.SET_GOODS_LIST, goods);
                    resolve(goods.goodsList);
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [types.GET_USER_PLAYED_GAME]({commit}, params) {
            return new Promise((resolve, reject) => {
                consumeApi.getPlayedGames(params, (playedGames) => {
                    commit(types.SET_USER_PLAYED_GAME, playedGames);
                    resolve();
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [types.GET_SERVER_LIST]({commit}, params) {
            return new Promise((resolve, reject) => {
                consumeApi.getServerList(params, (serverList) => {
                    let server = {
                        appId: params.appId,
                        areaId: params.areaId,
                        serverList: serverList
                    };
                    commit(types.SET_SERVER_LIST, server);
                    resolve(serverList);
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [types.GET_ROLE_INFO]({commit}, params) {
            return new Promise((resolve, reject) => {
                consumeApi.getRoleInfo(params, (roleInfo) => {
                    resolve(roleInfo);
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        },
        [types.EG_BUY_GOODS]({commit}, params) {
            return new Promise((resolve, reject) => {
                consumeApi.egBuyGoods(params, (apiResult) => {
                    resolve(apiResult);
                }, (errorCode) => {
                    reject(errorCode);
                })
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/consume.js